import { render, staticRenderFns } from "./CalendarLoader.vue?vue&type=template&id=d56716d4&scoped=true"
import script from "./CalendarLoader.vue?vue&type=script&lang=js"
export * from "./CalendarLoader.vue?vue&type=script&lang=js"
import style0 from "./CalendarLoader.vue?vue&type=style&index=0&id=d56716d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56716d4",
  null
  
)

export default component.exports